import {
  ALL_EXCLUDED,
  ALL_NEW_TITLE,
  BOOKSTAT_DATA,
  COMPETITORS,
  PENDING_EXCLUSION,
  PODIUM_SALES,
  PODIUM_TITLES,
  SEND_TO_CRM,
  WATCHLIST,
  CONTACTED,
  MANUALLY_ADDED,
  AUTHORS,
  PODIUMAUTHORS,
  RISING_STARS,
  TRENDING,
  POPULAR,
  WATCHLIST_RR,
  PENDING_EXCLUSION_RR,
  ALL_EXCLUDED_RR,
  PODIUM_TITLES_RR,
  ALL_TITLES_RR,
  DAILY_RANK_EBOOKS,
  DAILY_RANK_AUDIO_BOOKS,
  DAILY_RANK_CATALOGUE,
  SAVED_SEARCHES,
  HOT_TITLES,
  TOP_DEBUT_TITLES,
  KU_TOP_100,
  RESURFACED_EXCLUDED,
  TOP_POD_TITLES,
  CONTACTED_RR,
  SENT_TO_CRM_RR,
  MUTED_AUTHORS,
  MUTED_AUTHORS_RR,
  DAILY_RANK_PRINT,
  POPULAR_AO3,
  WATCHLIST_AO3,
  CONTACTED_AO3,
  PENDING_EXCLUSION_AO3,
  PODIUM_TITLES_AO3,
  ALL_EXCLUDED_AO3,
  SENT_TO_CRM_AO3,
  MUTED_AUTHORS_AO3
} from './endpoints';

export const Routes = {
  admin: '/',
  allExcluded: '/bookstat/all-excluded',
  allNewTitle: '/bookstat/all-new-titles',
  hotTitles: '/bookstat/hot-titles',
  topDebutTitles: '/bookstat/top-debut-titles',
  kuTop100: '/bookstat/ku-top-100',
  resurfacedKindleExcluded: '/bookstat/resurfaced-kindle-excluded',
  topPodTitles: '/bookstat/top-pod-titles',
  bookstat: '/bookstat',
  bookstatData: '/bookstat/bookstat-data',
  competitors: '/bookstat/competitors',
  dashboard: '/dashboard',
  forgotPass: '/forgot-password',
  login: '/login',
  mcpAuthorize: '/mcp/authorize',
  customLogin: '/custom-login',
  pendingExclusion: '/bookstat/pending-exclusion',
  podiumSales: '/bookstat/podium-sales',
  podiumTitles: '/bookstat/podium-titles',
  sentToCrm: '/bookstat/sent-to-crm',
  tabs: '/:tab',
  users: '/users',
  watchlist: '/bookstat/watchlist',
  contacted: '/bookstat/contacted',
  mutedAuthors: '/bookstat/muted-authors',
  manuallyAdded: '/bookstat/manually-added-titles',
  savedSearchesBookstat: '/bookstat/my-saved-searches',
  royalRoad: '/royal-road',
  pendingExclusionRR: '/royal-road/pending-exclusion',
  excludedRoyalRoad: '/royal-road/all-excluded',
  allTitlesRoyalRoad: '/royal-road/all-new-titles',
  sentToCrmRoyalRoad: '/royal-road/sent-to-crm',
  watchlistRoyalRoad: '/royal-road/watchlist',
  contactedRoyalRoad: '/royal-road/contacted',
  popular: '/royal-road/popular',
  risingStars: '/royal-road/rising-stars',
  trending: '/royal-road/trending',
  authors: '/royal-road/authors',
  podiumAuthors: '/royal-road/podium-authors',
  mutedAuthorsRoyalRoad: '/royal-road/muted-authors',
  podiumTitlesRoyalRoad: '/royal-road/podium-titles',
  savedSearchesRoyalRoad: '/royal-road/my-saved-searches',
  dailyRank: '/daily-rank',
  dailyRankAudiobooks: '/daily-rank/audio-books',
  dailyRankEbooks: '/daily-rank/ebooks',
  dailyRankCatalogue: '/daily-rank/catalogue',
  dailyRankPrint: '/daily-rank/print',
  savedSearchesDailyRank: '/daily-rank/my-saved-searches',
  usersAdminDashboard: '/users-admin-dashboard',
  pipelineProgress: '/pipeline-progress',
  ao3: '/ao3',
  ao3Popular: '/ao3/popular',
  ao3Watchlist: '/ao3/watchlist',
  ao3Contacted: '/ao3/contacted',
  ao3PendingExclusion: '/ao3/pending-exclusion',
  ao3PodiumTitles: '/ao3/podium-titles',
  ao3Excluded: '/ao3/all-excluded',
  ao3SentToCRM: '/ao3/sent-to-crm',
  ao3mutedAuthors: '/ao3/muted-authors'
};

export const TAB_NAME = {
  [ALL_NEW_TITLE]: 'All New Titles',
  [HOT_TITLES]: 'Hot Titles',
  [TOP_DEBUT_TITLES]: 'Top Debut Titles',
  [KU_TOP_100]: 'KU Top 100',
  [RESURFACED_EXCLUDED]: 'Resurfaced Kindle Excluded',
  [TOP_POD_TITLES]: 'Top POD',
  [ALL_EXCLUDED]: 'Excluded',
  [BOOKSTAT_DATA]: 'Bookstat Data',
  [COMPETITORS]: 'Competitors',
  [PENDING_EXCLUSION]: 'Pending Exclusion',
  [PODIUM_SALES]: 'Podium Sales',
  [PODIUM_TITLES]: 'Podium Titles',
  [SEND_TO_CRM]: 'Sent to CRM',
  [MUTED_AUTHORS]: 'Muted Authors',
  [WATCHLIST]: 'Watchlist',
  [CONTACTED]: 'Contacted',
  [MANUALLY_ADDED]: 'Manually Added',
  [ALL_TITLES_RR]: 'All Titles',
  [WATCHLIST_RR]: 'Watchlist',
  [CONTACTED_RR]: 'Contacted',
  [PENDING_EXCLUSION_RR]: 'Pending Exclusion',
  [ALL_EXCLUDED_RR]: 'Excluded',
  [POPULAR]: 'Popular',
  [POPULAR_AO3]: 'Popular',
  [RISING_STARS]: 'Rising Stars',
  [TRENDING]: 'Trending',
  [AUTHORS]: 'All Authors',
  [PODIUMAUTHORS]: 'Podium Authors',
  [MUTED_AUTHORS_RR]: 'Muted Authors',
  [PODIUM_TITLES_RR]: 'Podium Titles',
  [SENT_TO_CRM_RR]: 'Sent to CRM',
  [DAILY_RANK_EBOOKS]: 'E-Books',
  [DAILY_RANK_AUDIO_BOOKS]: 'Audiobooks',
  [DAILY_RANK_CATALOGUE]: 'Audiobooks & E-Books Catalogue',
  [DAILY_RANK_PRINT]: 'Print',
  [SAVED_SEARCHES]: 'My Searches',
  [WATCHLIST_AO3]: 'Watchlist',
  [CONTACTED_AO3]: 'Contacted',
  [PENDING_EXCLUSION_AO3]: 'Pending Exclusion',
  [PODIUM_TITLES_AO3]: 'Podium Titles',
  [ALL_EXCLUDED_AO3]: 'Excluded',
  [SENT_TO_CRM_AO3]: 'Sent To CRM',
  [MUTED_AUTHORS_AO3]: 'Muted Authors'
};